// extracted by mini-css-extract-plugin
export default {"topContainer":"breadcrumbs_topContainer__S1RNU"};